import type { MIProxyConfigOptions } from './types';

const DEFAULT_MIGIS_PROXY = '/api/v2/proxy';

export class MIProxyConfig {
  private config: Required<MIProxyConfigOptions>;

  constructor(options: MIProxyConfigOptions) {
    this.config = {
      enabled: options.enabled,
      proxyUrl: options.proxyUrl || DEFAULT_MIGIS_PROXY,
      mode: options.mode || 'migis',
      allowedDomains: options.allowedDomains || [],
      cacheResponses: options.cacheResponses !== false,
      cacheTTL: options.cacheTTL || 300,
    };
  }

  isEnabled(): boolean {
    return this.config.enabled;
  }

  resolveUrl(targetUrl: string): string {
    if (!this.config.enabled) return targetUrl;

    if (this.config.allowedDomains.length > 0) {
      try {
        const urlObj = new URL(targetUrl);
        const isAllowed = this.config.allowedDomains.some(
          domain => urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`)
        );
        if (!isAllowed) return targetUrl;
      } catch {
        return targetUrl;
      }
    }

    const proxyBase = this.config.mode === 'custom' && this.config.proxyUrl
      ? this.config.proxyUrl
      : DEFAULT_MIGIS_PROXY;

    return `${proxyBase}?url=${encodeURIComponent(targetUrl)}`;
  }

  getConfig(): MIProxyConfigOptions {
    return { ...this.config };
  }

  static createMigisProxy(allowedDomains?: string[]): MIProxyConfig {
    return new MIProxyConfig({
      enabled: true,
      mode: 'migis',
      allowedDomains,
    });
  }

  static createCustomProxy(proxyUrl: string, allowedDomains?: string[]): MIProxyConfig {
    return new MIProxyConfig({
      enabled: true,
      mode: 'custom',
      proxyUrl,
      allowedDomains,
    });
  }
}
